import { TenderMethod } from '@rygen/rygen-ui/model';

export class TenderRejectRequest {
  responseMethod: TenderMethod;
  reason?: string;
  comment?: string;
  accessToken?: string;

  constructor(
    responseMethod: TenderMethod,
    reason?: string,
    comment?: string,
    accessToken?: string,
  ) {
    this.responseMethod = responseMethod;
    this.reason = reason;
    this.comment = comment;
    this.accessToken = accessToken;
  }
}
